import React, { useState } from "react";
import "./Header.css";
import { Logo } from "../../images/images";
import { Link } from "react-router-dom";
import useAuth from "../../state/useAuth";

const links = [
  { text: "Home", href: "/" },
  { text: "About", href: "/about" },
  { text: "Teachings", href: "/teachings" },
  { text: "Prayer Requests", href: "/prayer" },
  { text: "Give", href: "/donate" },
  { text: "Blog", href: "/blog" },
  { text: "Contact Us", href: "/contact" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isLoggedIn, full_name, email, avatar } = useAuth();
  const displayName = full_name?.trim() || email?.split("@")[0] || "Your profile";
  const initials = displayName
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return (
    <header className="header">
      <nav className="header-nav">
        {/* Logo */}
        <div className="header-logo" style={{ cursor: "pointer" }}>
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
        </div>

        {/* Center Links */}
        <div className="header-links">
          {links.map((link) =>
            link.href.startsWith("http") ? (
              <a
                key={link.text}
                href={link.href}
                className="header-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.text}
              </a>
            ) : (
              <Link key={link.text} to={link.href} className="header-link">
                {link.text}
              </Link>
            )
          )}
        </div>

        <div className="header-actions">
          {isLoggedIn && (
            <div className="header-profile" aria-label={`Signed in as ${displayName}`}>
              {avatar ? (
                <img className="header-profile-avatar" src={avatar} alt="" />
              ) : (
                <span className="header-profile-avatar header-profile-initials" aria-hidden="true">
                  {initials || "U"}
                </span>
              )}
              <span className="header-profile-copy">
                <span className="header-profile-name">{displayName}</span>
                {email && <span className="header-profile-email">{email}</span>}
              </span>
            </div>
          )}

          {/* Keep section navigation available for signed-in and guest visitors. */}
          <button
            type="button"
            className="header-hamburger"
            aria-label={mobileOpen ? "Close navigation sections" : "Open navigation sections"}
            aria-expanded={mobileOpen}
            aria-controls="header-navigation-sections"
            onClick={() => setMobileOpen((open) => !open)}
          >
            <span className="header-hamburger-icon" aria-hidden="true">
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
            </span>
          </button>
        </div>
      </nav>

      {/* Mobile Links */}
      <div id="header-navigation-sections" className={`header-mobile-links${mobileOpen ? " open" : ""}`}>
        {links.map((link) =>
          link.href.startsWith("http") ? (
            <a
              key={link.text}
              href={link.href}
              className="header-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileOpen(false)}
            >
              {link.text}
            </a>
          ) : (
            <Link
              key={link.text}
              to={link.href}
              className="header-link"
              onClick={() => setMobileOpen(false)}
            >
              {link.text}
            </Link>
          )
        )}
      </div>
    </header>
  );
};

export default Header;
